
const emailTemplates = {
  presupuesto: {
    EN: {
      asunto: (codigo) => `Proposal Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hello ${data.cliente_nombre},

Thank you very much for contacting Rutas Meigas.      

${getPresupuestoPrimerPaso('EN', data.camino_id)}You are about to embark on a life-changing experience full of learning, which requires some effort, but above all, will bring you joy and satisfaction. You'll see that, if you decide to keep moving forward, it will truly be an unforgettable journey.

Please click the button below to view your quote, with reference number: ${data.codigo}

We look forward to hearing from you, and once again, thank you for contacting us.

${getPresupuestoDespedida('EN', data.camino_id)}
  
${data.usuario}`
    },
    DE: {
      asunto: (codigo) => `Angebot Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hallo ${data.cliente_nombre},

Vielen Dank, dass du dich für Rutas Meigas entschieden hast, um dich auf diesem besonderen Weg zu begleiten.

${getPresupuestoPrimerPaso('DE', data.camino_id)}Der Weg wird dir viele schöne Momente schenken: beeindruckende Landschaften, besondere Begegnungen und Augenblicke, die du so schnell nicht vergessen wirst. Natürlich gehört auch ein wenig Anstrengung dazu – aber genau das macht den Camino so einzigartig.

Wenn du dich entscheidest, diesen Weg hier weiterzugehen, wartet mit Sicherheit ein unvergessliches Erlebnis auf dich.

Über den folgenden Link kannst du dein persönliches Angebot mit der Referenznummer ${data.codigo} aufrufen und alle Details in Ruhe ansehen.

Wir würden uns sehr darauf freuen, dich auf deinem Weg begleiten zu dürfen.

${getPresupuestoDespedida('DE', data.camino_id)}
  
${data.usuario}`
    },
    ES: {
      asunto: (codigo) => `Propuesta Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hola ${data.cliente_nombre},

Muchas gracias por contactar con Rutas Meigas.

${getPresupuestoPrimerPaso('ES', data.camino_id)}Estás a punto de descubrir una experiencia vital llena de aprendizaje, que requiere un poco de esfuerzo y que te aportará, sobre todo, alegría y satisfacción. Verás que, si te decides a seguir avanzando, será realmente algo inolvidable.

Por favor haz click en el botón abajo para ver tu presupuesto, con número de referencia: <b>${data.codigo}</b>

Esperamos tu respuesta y nuevamente muchas gracias por contactarnos.

${getPresupuestoDespedida('ES', data.camino_id)}
  
Saludos
${data.usuario}`
    }
  },
  confirmacion: {
    EN: {
      asunto: (codigo) => `Confirmation Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hello ${data.cliente_nombre},

We can now confirm your Camino!
      
Here is the confirmation for your Camino from ${data.desde} to ${data.hasta}, where you will see all the accommodations where you will be staying:
      
Additionally, I am attaching the following:
 - <b>Tips for the Camino</b>
 - <b>Traveler Registration Form</b> 
 - <b>Credit Card Charge Authorization (VISA OR MASTER CARD)</b> 
       
For now, I don't need anything else from you. 
      
Now you just need to make the deposit payment (100.0€) to guarantee your reservation. The remaining payment must be made 10 days before starting the Camino.

ACCOUNT HOLDER: RUTAS MEIGAS SL
BANK: Banco Sabadell
IBAN: ES38 0081 0499 6400 0188 1494
BIC: BSABESBB

On that date, I will also send you the insurance policy, reservation vouchers (accommodations and services), an informative dossier, and the pro forma invoice so you can make the pending payment.
      
If you have any questions, don't hesitate to write to me.
      
Best regards,

${data.usuario}`      

    },
    DE: {
      asunto: (codigo) => `Bestätigung Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hallo ${data.cliente_nombre},

Wir können deinen Jakobsweg jetzt bestätigen!
      
Hier ist die Bestätigung für deinen Jakobsweg von ${data.desde} nach ${data.hasta}, dort siehst du alle Unterkünfte, in denen du übernachten wirst:
      
Zusätzlich füge ich Folgendes bei:
 - <b>Tipps für den Jakobsweg</b>
 - <b>Reiseanmeldeformular</b> 
 - <b>Kreditkartenabbuchungsermächtigung (VISA ODER MASTER CARD)</b> 
     
Im Moment benötige ich nichts weiter von dir. 
      
Jetzt musst du nur noch die Anzahlung (100,0€) leisten, um deine Reservierung zu garantieren. Die Restzahlung muss 10 Tage vor Beginn des Jakobswegs erfolgen.

KONTOINHABER: RUTAS MEIGAS SL
BANK: Banco Sabadell
IBAN: ES38 0081 0499 6400 0188 1494
BIC: BSABESBB

Zu diesem Zeitpunkt sende ich dir auch die Versicherungspolice, die Reservierungsgutscheine (Unterkünfte und Dienstleistungen), ein Informationsdossier und die Proforma-Rechnung, damit du die ausstehende Zahlung vornehmen kannst.
      
Wenn du Fragen hast, zögere nicht, mir zu schreiben.
      
Viele Grüße,

${data.usuario}`
    },
    ES: {
      asunto: (codigo) => `Confirmación Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Hola ${data.cliente_nombre},

¡Ya podemos confirmar vuestro Camino!

Te dejo aquí la confirmación de vuestro camino desde ${data.desde} a ${data.hasta}, ahí verás todos los alojamientos donde os vais a quedar:

Además, os adjunto lo siguiente:
- <b>Tips para el Camino</b>
- <b>Registro de viajeros</b> 
- <b>Autorización cargo tarjeta de crédito (VISA O MASTER CARD)</b> 
 
Por el momento no necesito nada más por tu parte. 

Ahora solo tenéis que hacer el pago del depósito (100,0€), para garantizar vuestra reserva. El resto del pago lo tenéis que hacer 10 días antes de comenzar el camino.

TITULAR DE LA CUENTA: RUTAS MEIGAS SL
ENTIDAD BANCARIA: Banco Sabadell
IBAN: ES38 0081 0499 6400 0188 1494
BIC: BSABESBB

En esa fecha te enviaré también la póliza de los seguros, los bonos de la reserva (alojamientos y servicios), un dossier informativo y la factura pro forma para que podáis hacer el pago pendiente.

Si tienes cualquier pregunta no dudes en escribirme.

Un saludo,

${data.usuario}`
    }
  },
  documentacion: {
    EN: {
      asunto: (codigo) => `Documentation Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Good morning ${data.cliente_nombre},

I hope you are doing great.

In just a few days you will be enjoying the Camino de Santiago.
 
At the end of the email, you will find all the necessary documentation for the Camino.
You don't need to print the vouchers, you can have them on your mobile phone.

<span style="color: red;"><b>Please review everything carefully and if you have any questions, write to me and we'll go over it.</b></span>

On the day of your arrival in ${data.desde} on <b>${data.fecha_llegada}</b>, you will receive the welcome package when you check in at the accommodation <b>${data.alojamiento_desde}</b>. Please make sure they give you this package, it contains among other things: Pilgrim's credential, luggage identification tag, scallop shell...

Here are some links with useful information:

· <a href="https://oficinadelperegrino.com/">Pilgrim's Office</a> website. 
· Page with the <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">Cathedral mass</a> schedules. 
· Page with a form to <a href="https://oficinadelperegrino.com/registro-individual/">pre-register for your Compostela/</a>, they will send you a code by SMS or email. It is recommended to do this before your arrival in Santiago.


I also provide you with our 24-hour emergency phone number: <span style="background-color: yellow;"><b>+34 619 38 87 36. If you need to contact us for any problem or emergency during your Camino, you can call us at this number.</b></span> 

A big hug and once again thank you very much for letting us organize your Camino.  
 
<b>Buen Camino!</b>

${data.usuario}`
    },
    DE: {
      asunto: (codigo) => `Bestätigung Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
            `Guten Morgen ${data.cliente_nombre},

Ich hoffe, es geht DIR sehr gut.

In wenigen Tagen wirst du den Jakobsweg genießen.

Am Ende der E-Mail findest du alle erforderlichen Unterlagen für den Camino.
Du musst die Gutscheine nicht ausdrucken, du kannst sie auf deinem Mobiltelefon haben.

<span style="color: red;"><b>Bitte überprüfe alles sorgfältig und wenn du Fragen hast, schreibe mir und wir besprechen es.</b></span>

Am Tag deiner Ankunft in ${data.desde} am <b>${data.fecha_llegada}</b> erhältst du beim Check-in in der Unterkunft <b>${data.alojamiento_desde}</b> das Willkommenspaket. Bitte stelle sicher, dass du dieses Paket erhältst, es enthält unter anderem: Pilgerausweis, Gepäckidentifikationsetikett, Jakobsmuschel...

Hier sind einige Links mit nützlichen Informationen:

· Website des <a href="https://oficinadelperegrino.com/">Pilgerbüros</a>. 
· Seite mit den <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">Messezeiten der Kathedrale</a>. 
· Seite mit einem Formular zur <a href="https://oficinadelperegrino.com/registro-individual/">Voranmeldung für deine Compostela</a>, du erhältst einen Code per SMS oder E-Mail. Es wird empfohlen, dies vor deiner Ankunft in Santiago zu tun.

Ich gebe dir auch unsere 24-Stunden-Notrufnummer: <span style="background-color: yellow;"><b>+34 619 38 87 36. Wenn du uns wegen eines Problems oder Notfalls während deines Jakobswegs kontaktieren musst, kannst du uns unter dieser Nummer anrufen.</b></span> 

Eine herzliche Umarmung und nochmals vielen Dank, dass du uns deinen Jakobsweg organisieren lässt.  

<b>Buen Camino!</b>

${data.usuario}`
    },
    ES: {
      asunto: (codigo) => `Documentación Rutas Meigas - ${codigo}`,
      cuerpo: (data) =>
        `Buenos días ${data.cliente_nombre},

Espero que os encontréis genial.

En pocos días ya estaréis disfrutando del Camino de Santiago.
 

Al final del correo encontrarás toda la documentación necesaria para el Camino.
No es necesario que imprimas los bonos, puedes tenerlos en tu teléfono móvil.

<span style="color: red;"><b>Por favor, revisa todo bien y si tienes alguna duda me escribes y lo vemos.</b></span>

El día de vuestra llegada a ${data.desde} el <b>${data.fecha_llegada}</b> os entregarán el paquete de bienvenida al realizar el check in en el alojamiento <b>${data.alojamiento_desde}</b>. Por favor, asegúrate de que te entregan este paquete, contiene entre otras cosas: Credencial del peregrino, etiqueta de identificación para el equipaje, concha de peregrino...

Os paso unos links con información útil:

· Página web de la <a href="https://oficinadelperegrino.com/">oficina del peregrino</a>.
· Página con los horarios de las <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">misas de la Catedral</a>.
· Página con un formulario para que hagáis el <a href="https://oficinadelperegrino.com/registro-individual/">pre registro para vuestra Compostela</a>, os enviarán un código por SMS o correo electrónico. Se recomienda hacerlo antes de vuestra llegada a Santiago.

Te indico también nuestro teléfono de emergencias operativo las 24 horas para que lo tengas: <span style="background-color: yellow;"><b>+34 619 38 87 36</b>. Si necesitas contactar con nosotros por algún problema o emergencia durante tu camino puedes llamarnos a ese teléfono.</span> 

Un fuerte abrazo y nuevamente muchas gracias por dejarnos organizar vuestro Camino.  
 
<b>¡Buen Camino!</b>

${data.usuario}`
    }
  },
  resena: {
    EN: {
      asunto: () => 'Thank you from Rutas Meigas!',
      cuerpo: (data) =>
        `Hello ${data.cliente_nombre},

I hope you have enjoyed the Camino and have an unforgettable experience.

On behalf of the entire Rutas Meigas team and of course on my part, we would like to thank you for choosing us to organize your Camino de Santiago.

It would be of great help to us and also to other people who are interested in doing the Camino de Santiago, if you took a few minutes to rate your experience on <a href="https://g.page/RutasMeigas/review">Google</a> and <a href="https://www.tripadvisor.es/Attraction_Review-g187508-d17424882-Reviews-Rutas_Meigas-Santiago_de_Compostela_Province_of_A_Coruna_Galicia.html">Tripadvisor</a>.

I'll wait for you on the next Camino, you are a professional in this!${data.textoCuestionario}

Greetings and have a happy return home,

${data.usuario}`
    },
    DE: {
      asunto: () => 'Vielen Dank von Rutas Meigas!',
      cuerpo: (data) =>
        `Hallo ${data.cliente_nombre},

ich hoffe, du/ihr hast/habt Deinen/Euren Camino genossen und eine unvergessliche Zeit gehabt.

Im Namen des gesamten Teams von Rutas Meigas, möchte ich dir/euch herzlich dafür danken, dass du uns für die Organisation deines Jakobsweges ausgesucht hast.

Es wäre prima und auch eine Hilfe für weitere Pilger, welche am Jakobsweg interessiert sind, wenn du dir ein paar Minuten Zeit nehmen würdest, um deine Erfahrung mit uns auf <a href="https://g.page/RutasMeigas/review">Google</a> und <a href="https://www.tripadvisor.es/Attraction_Review-g187508-d17424882-Reviews-Rutas_Meigas-Santiago_de_Compostela_Province_of_A_Coruna_Galicia.html">Tripadvisor</a> zu bewerten.

Wir erwarten Dich/Euch für euren nächsten Jakobsweg!${data.textoCuestionario}

Liebe Grüße und eine gute Heimreise!

${data.usuario}`
    },
    ES: {
      asunto: () => 'Muchas gracias desde Rutas Meigas!',
      cuerpo: (data) =>
        `Buenas tardes ${data.cliente_nombre},

Espero que hayáis disfrutado del camino y os llevéis una experiencia inolvidable.

De parte de todo el equipo de Rutas Meigas y por supuesto de mi parte, nos gustaría agradeceros que nos hayáis elegido para organizar vuestro Camino de Santiago.

Sería de gran ayuda para nosotros y también para otras personas que estén interesadas en realizar el Camino de Santiago, que te tomases unos minutos valorando tu experiencia en <a href="https://g.page/RutasMeigas/review">Google</a> y en <a href="https://www.tripadvisor.es/Attraction_Review-g187508-d17424882-Reviews-Rutas_Meigas-Santiago_de_Compostela_Province_of_A_Coruna_Galicia.html">Tripadvisor</a>.

Os espero para el siguiente Camino, ¡ya sois todos unos veteranos en esto!${data.textoCuestionario}

Un saludo y que tengáis un feliz regreso a casa,

${data.usuario}`
    }
  }
}


export function generarEmailContenidoPresupuesto(modelReserva, usuario) {
  const idioma = modelReserva.language?.toUpperCase() || 'ES';
  const template = emailTemplates['presupuesto']?.[idioma] || emailTemplates['presupuesto']?.ES;
  const esAgencia = esReservaAgencia(modelReserva);

  if (!template) {
    console.error(`No se encontró template para presupuesto, idioma: ${idioma}`);
    return {
      asunto: `Rutas Meigas - ${modelReserva.codigo}`,
      cuerpo: ''
    };
  }

  const data = {
    cliente_nombre: capitalize(modelReserva.cliente?.nombre) || '',
    destinatario_nombre: getNombreDestinatarioCorreo(modelReserva),
    codigo: modelReserva.codigo,
    camino_id: modelReserva.camino?.id,
    usuario: usuario?.nombre || '',
    origen_nombre: modelReserva.origen?.nombre || '',
    origen_identificador: modelReserva.origen?.identificador || '',
  };

  if (esAgencia) {
    return {
      asunto: template.asunto(modelReserva.codigo),
      cuerpo: getPlantillaPresupuestoAgencia(idioma, data),
    };
  }

  return {
    asunto: template.asunto(modelReserva.codigo),
    cuerpo: template.cuerpo(data)
  };
}

export function generarEmailContenidoConfirmacion(modelReserva, usuario) {
  const idioma = modelReserva.language?.toUpperCase() || 'ES';
  const template = emailTemplates['confirmacion']?.[idioma] || emailTemplates['confirmacion']?.ES;
  const esAgencia = esReservaAgencia(modelReserva);

  if (!template) {
    console.error(`No se encontró template para confirmación, idioma: ${idioma}`);
    return {
      asunto: '',
      cuerpo: ''
    };
  }
  const desde = modelReserva.camino.etapas.at(0).final_punto.nombre;
  const hasta = modelReserva.camino.etapas.at(-1).final_punto.nombre;
  

  const resumenEtapas = getResumenEtapas(modelReserva);

  const desc_fechas = resumenEtapas.map(etapa => `<span style="color: red;"><b>${etapa.fecha}</b></span> Día ${etapa.dia}: ${etapa.subtitulo}.${etapa.subtitulo_barco}${etapa.nota_extra}<b>${etapa.proveedor_nombre}</b>`).join('\n');

  const data = {
    cliente_nombre: capitalize(modelReserva.cliente?.nombre) || '',
    destinatario_nombre: getNombreDestinatarioCorreo(modelReserva),
    codigo: modelReserva.codigo,
    usuario: usuario?.nombre || '',
    desde: desde,
    hasta: hasta,
    camino: modelReserva.camino.titulo.toUpperCase(),
    duracion: modelReserva.camino.duracion,
    cliente_nomb_completo: (modelReserva.cliente?.nombre || '') + ' ' + (modelReserva.cliente?.apellidos || ''),
    peregrinos: modelReserva.cant_peregrinos,
    desc_habitaciones: getCaptionHabitaciones(modelReserva, idioma),
    desc_fechas: desc_fechas,
    desc_reserva: modelReserva.descripcion_importe_reserva,
    desc_servicios: 'desc servicios',
    importe: modelReserva.importe_presupuestado + '€',
    origen_nombre: modelReserva.origen?.nombre || '',
    origen_identificador: modelReserva.origen?.identificador || '',
  };

  if (esAgencia) {
    return {
      asunto: template.asunto(modelReserva.codigo),
      cuerpo: getPlantillaConfirmacionAgencia(idioma, data),
    };
  }

  return {
    asunto: template.asunto(modelReserva.codigo),
    cuerpo: template.cuerpo(data)
  };
}

export function generarEmailContenidoDocumentacion(modelReserva, usuario) {
  const idioma = modelReserva.language?.toUpperCase() || 'ES';
  const template = emailTemplates['documentacion']?.[idioma] || emailTemplates['documentacion']?.ES;
  const esAgencia = esReservaAgencia(modelReserva);

  if (!template) {
    console.error(`No se encontró template para documentacion, idioma: ${idioma}`);
    return {
      asunto: `Rutas Meigas - ${modelReserva.codigo}`,
      cuerpo: ''
    };
  }

  const desde = modelReserva.camino.etapas.at(0).final_punto.nombre;
  const hasta = modelReserva.camino.etapas.at(-1).final_punto.nombre;
  const data = {
    cliente_nombre: capitalize(modelReserva.cliente?.nombre) || '',
    destinatario_nombre: getNombreDestinatarioCorreo(modelReserva),
    codigo: modelReserva.codigo,
    usuario: usuario?.nombre || '',
    desde: desde,
    hasta: hasta,
    fecha_llegada: modelReserva.fecha_llegada ? new Date(modelReserva.fecha_llegada).toLocaleDateString('es-ES', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    })
  : '',
    alojamiento_desde: modelReserva.etapas.at(0).pivot.proveedor_nombre || '',
    origen_nombre: modelReserva.origen?.nombre || '',
  };

  if (esAgencia) {
    return {
      asunto: template.asunto(modelReserva.codigo),
      cuerpo: getPlantillaDocumentacionAgencia(idioma, data),
    };
  }


  return {
    asunto: template.asunto(modelReserva.codigo),
    cuerpo: template.cuerpo(data)
  };
}

export function generarEmailContenidoResena(modelReserva, usuario, enviarCuestionario = false) {
  const idioma = modelReserva.language?.toUpperCase() || 'ES';
  const template = emailTemplates.resena?.[idioma] || emailTemplates.resena?.ES;

  if (!template) {
    console.error(`No se encontró template para reseña, idioma: ${idioma}`);
    return {
      asunto: 'Muchas gracias desde Rutas Meigas!',
      cuerpo: ''
    };
  }

  const data = {
    cliente_nombre: capitalize(modelReserva.cliente?.nombre) || '',
    usuario: usuario?.nombre || '',
    textoCuestionario: enviarCuestionario ? `\n\n${getTextoCuestionario(idioma)}` : '',
  };

  return {
    asunto: template.asunto(),
    cuerpo: template.cuerpo(data)
  };
}

function getTextoCuestionario(idioma) {
  const textos = {
    ES: 'Te enviamos también un enlace a un breve cuestionario. Nos sería de gran ayuda que pudieras dedicar unos minutos a completarlo.',
    EN: 'We are also sending you a link to a short questionnaire. It would be of great help to us if you could take a few minutes to complete it.',
    DE: 'Wir senden dir/euch auch einen Link zu einem kurzen Fragebogen. Es wäre uns eine große Hilfe, wenn du/ihr euch ein paar Minuten Zeit nehmen könntest/könntet, ihn auszufüllen.',
  };

  return textos[idioma] || textos.ES;
}

function getCaptionHabitaciones(reserva, language) {
  const traducciones = {
    'ES': {
      'individual': 'individual',
      'dobleMat': 'doble (Mat)',
      'doble2Ind': 'doble (2 Ind)',
      'triple': 'triple',
      'individuales': 'individuales',
      'doblesMat': 'dobles (Mat)',
      'dobles2Ind': 'dobles (2 Ind)',
      'triples': 'triples'
    },
    'EN': {
      'individual': 'single',
      'dobleMat': 'double (1 bed)',
      'doble2Ind': 'double (2 single beds)',
      'triple': 'triple',
      'individuales': 'singles',
      'doblesMat': 'doubles (1 bed)',
      'dobles2Ind': 'doubles (2 single beds)',
      'triples': 'triples'
    },
    'DE': {
      'individual': 'Einzelzimmer',
      'dobleMat': 'Doppelzimmer (1 Doppelbett)',
      'doble2Ind': 'Doppelzimmer (2 Einzelbetten)',
      'triple': 'Dreibettzimmer',
      'individuales': 'Einzelzimmer',
      'doblesMat': 'Doppelzimmer (1 Doppelbett)',
      'dobles2Ind': 'Doppelzimmer (2 Einzelbetten)',
      'triples': 'Dreibettzimmer'
    }
  };

  const habitaciones = [];

  if (reserva.cant_habitaciones_individuales > 0) {
    habitaciones.push(
      reserva.cant_habitaciones_individuales + ' ' + 
      (reserva.cant_habitaciones_individuales > 1 
        ? traducciones[language]['individuales'] 
        : traducciones[language]['individual'])
    );
  }

  if (reserva.cant_habitaciones_dobles > 0) {
    habitaciones.push(
      reserva.cant_habitaciones_dobles + ' ' + 
      (reserva.cant_habitaciones_dobles > 1 
        ? traducciones[language]['dobles2Ind'] 
        : traducciones[language]['doble2Ind'])
    );
  }

  if (reserva.cant_habitaciones_dobles_matrimoniales > 0) {
    habitaciones.push(
      reserva.cant_habitaciones_dobles_matrimoniales + ' ' + 
      (reserva.cant_habitaciones_dobles_matrimoniales > 1 
        ? traducciones[language]['doblesMat'] 
        : traducciones[language]['dobleMat'])
    );
  }

  if (reserva.cant_habitaciones_triples > 0) {
    habitaciones.push(
      reserva.cant_habitaciones_triples + ' ' + 
      (reserva.cant_habitaciones_triples > 1 
        ? traducciones[language]['triples'] 
        : traducciones[language]['triple'])
    );
  }

  return habitaciones.join(', ');
}

function getResumenEtapas(reserva) {
  const resumen = [];
  // Asumiendo que las etapas ya vienen ordenadas por fecha en el objeto reserva
  const etapas = reserva.etapas || [];
  let dia = 1;
  const language = reserva.language;

  etapas.forEach(etapa => {
    const subtitulo_barco = {
      'ES': 'Traslado en barco por la ría de Arousa y río Ulla.',
      'EN': 'Transfer by boat from Vilanova to Pontecesures.',
      'DE': 'Boot von Vilanova nach Pontecesures.'
    };

    resumen.push({
      subtitulo: etapa.pivot?.descripcion || etapa.descripcion || '',
      subtitulo_barco: etapa.id == 74 ? subtitulo_barco[language] : '',
      dia: dia,
      proveedor_nombre: etapa.pivot?.proveedor_nombre 
        ? ' [' + etapa.pivot.proveedor_nombre + ']' 
        : '',
      fecha: etapa.pivot?.fecha 
        ? new Date(etapa.pivot.fecha).toLocaleDateString('es-ES', { 
            day: '2-digit', 
            month: '2-digit', 
            year: 'numeric' 
          }).replaceAll('/', '.')
        : '',
      nota_extra: etapa.pivot?.nota_extra ? '[' + etapa.pivot.nota_extra + ']' : ''
    });
    
    dia++;
  });

  return resumen;
}

const capitalize = (str) => {
  if (!str) return '';
  const normalized = str.toLowerCase();
  return normalized.replace(/(^|\s)(\S)/g, (match, sep, ch) => `${sep}${ch.toUpperCase()}`);
};

function esReservaAgencia(modelReserva) {
  return Number(modelReserva?.origen?.id || modelReserva?.origen_id || 0) > 1;
}

function getNombreDestinatarioCorreo(modelReserva) {
  return capitalize(
    modelReserva?.origen?.responsable ||
    modelReserva?.origen?.nombre ||
    modelReserva?.cliente?.nombre ||
    ''
  );
}

function getCodigoReservaConEnlace(data) {
  const codigo = `<b>${data.codigo}</b>`;
  const origenIdentificador = String(data?.origen_identificador || '').trim();

  if (!origenIdentificador || !data?.codigo) {
    return codigo;
  }

  const href = `https://centralreservas.rutasmeigas.com/central_reservas/ext/${encodeURIComponent(origenIdentificador)}?tab=expedientes&codigo=${encodeURIComponent(data.codigo)}`;

  return `<a href="${href}">${codigo}</a>`;
}

function getPlantillaPresupuestoAgencia(language, data) {
  const templates = {
    ES: `Hola ${data.destinatario_nombre},

Te enviamos el presupuesto con número de referencia ${getCodigoReservaConEnlace(data)}.

Un saludo,
${data.usuario}`,
    EN: `Hello ${data.destinatario_nombre},

Please find attached the proposal corresponding to reference ${getCodigoReservaConEnlace(data)}.

Best regards,
${data.usuario}`,
    DE: `Hallo ${data.destinatario_nombre},


Anbei senden wir Ihnen das Angebot zur Referenz ${getCodigoReservaConEnlace(data)}.

Viele Grüße,
${data.usuario}`,
  };

  return templates[language] || templates.ES;
}

function getPlantillaConfirmacionAgencia(language, data) {
  const templates = {
    ES: `Hola ${data.destinatario_nombre},

Te enviamos la confirmación de la reserva con referencia ${getCodigoReservaConEnlace(data)}.

Un saludo,
${data.usuario}`,
    EN: `Hello ${data.destinatario_nombre},

We are sending you the confirmation for booking reference ${getCodigoReservaConEnlace(data)}.

Best regards,
${data.usuario}`,
    DE: `Hallo ${data.destinatario_nombre},

wir senden Ihnen die Bestätigung für die Buchungsreferenz ${getCodigoReservaConEnlace(data)}.

Viele Grüße,
${data.usuario}`,
  };

  return templates[language] || templates.ES;
}

function getPlantillaDocumentacionAgencia(language, data) {
  const templates = {
    EN: `Good morning ${data.destinatario_nombre},

In just a few days the client will already be enjoying the Camino de Santiago.

At the end of the email, you will find all the necessary documentation so that you can forward it to them.
The client does not need to print the vouchers; they can keep them on their mobile phone.

<span style="color: red;"><b>Please review everything carefully and if you have any questions, write to me and we will go over it.</b></span>

On the day of their arrival in ${data.desde} on <b>${data.fecha_llegada}</b>, they will receive the welcome pack when checking in at the accommodation <b>${data.alojamiento_desde}</b>. It contains, among other things, the pilgrim credential, luggage identification tag, scallop shell...

Here are some useful links for you to forward to them:

· <a href="https://oficinadelperegrino.com/">Pilgrim's Office</a> website. 
· Page with the <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">Cathedral mass</a> schedules. 
· Page with a form to <a href="https://oficinadelperegrino.com/registro-individual/">pre-register for the Compostela</a>; they will receive a code by SMS or email. Please recommend that they do this before arriving in Santiago.

I am also including our 24-hour emergency phone number so you can pass it on to them: <span style="background-color: yellow;"><b>+34 619 38 87 36</b>. If they need to contact us because of any issue or emergency during the Camino, they can call this number.</span> 

A big hug and many thanks.  
 
<b>Buen Camino!</b>

${data.usuario}`,
    DE: `Guten Morgen ${data.destinatario_nombre},

In wenigen Tagen wird der Kunde bereits den Jakobsweg genießen.

Am Ende dieser E-Mail finden Sie alle erforderlichen Unterlagen, damit Sie sie an den Kunden weiterleiten können.
Der Kunde muss die Gutscheine nicht ausdrucken, er kann sie auf seinem Mobiltelefon mitführen.

<span style="color: red;"><b>Bitte prüfen Sie alles sorgfältig, und wenn Sie Fragen haben, schreiben Sie mir und wir sehen es uns gemeinsam an.</b></span>

Am Tag seiner Ankunft in ${data.desde} am <b>${data.fecha_llegada}</b> erhält er beim Check-in in der Unterkunft <b>${data.alojamiento_desde}</b> das Willkommenspaket. Es enthält unter anderem den Pilgerausweis, die Gepäckkennzeichnung und die Jakobsmuschel...

Hier sende ich Ihnen einige nützliche Links, damit Sie sie weiterleiten können:

· Website des <a href="https://oficinadelperegrino.com/">Pilgerbüros</a>. 
· Seite mit den <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">Messezeiten der Kathedrale</a>. 
· Seite mit einem Formular zur <a href="https://oficinadelperegrino.com/registro-individual/">Voranmeldung für die Compostela</a>; der Kunde erhält einen Code per SMS oder E-Mail. Empfehlen Sie ihm bitte, dies vor seiner Ankunft in Santiago zu erledigen.

Ich teile Ihnen auch unsere 24-Stunden-Notrufnummer mit, damit Sie sie weitergeben können: <span style="background-color: yellow;"><b>+34 619 38 87 36</b>. Falls während des Jakobswegs ein Problem oder Notfall auftritt, kann der Kunde uns unter dieser Nummer erreichen.</span> 

Eine herzliche Umarmung und vielen Dank.  

<b>Buen Camino!</b>

${data.usuario}`,
    ES: `Buenos días ${data.destinatario_nombre},

En pocos días tu cliente estará disfrutando del Camino de Santiago.

Al final de este correo encontrarás toda la documentación necesaria para que se la puedas enviar.
No hace falta que el cliente imprima los bonos, puede llevarlos en su teléfono móvil.

<span style="color: red;"><b>Por favor, revisa todo bien y si tienes alguna duda me escribes de vuelta y lo vemos.</b></span>

El día de su llegada a ${data.desde} el <b>${data.fecha_llegada}</b> se le entregará al cliente el paquete de bienvenida al realizar el check in en el alojamiento <b>${data.alojamiento_desde}</b>. Contiene, entre otras cosas, la credencial del peregrino, la etiqueta de identificación para el equipaje y la concha de peregrino.

Te paso también unos links con información útil para que se los reenvíes:

· Página web de la <a href="https://oficinadelperegrino.com/">oficina del peregrino</a>.
· Página con los horarios de las <a href="https://catedraldesantiago.es/liturgia/#horarios-misas">misas de la Catedral</a>.
· Página con un formulario para que el cliente haga el <a href="https://oficinadelperegrino.com/registro-individual/">pre registro para la Compostela</a>, para lo que le llegará después un código por SMS o correo electrónico. Recomiéndale que lo hagan antes de su llegada a Santiago.

Te indico también nuestro teléfono de emergencias operativo las 24 horas para que se lo hagas llegar: <span style="background-color: yellow;"><b>+34 619 38 87 36</b>. Si necesitan contactar con nosotros por algún problema o emergencia durante su camino pueden llamarnos a ese teléfono.</span>

Un fuerte abrazo y muchas gracias.  
 
<b>¡Buen Camino!</b>

${data.usuario}`,
  };

  return templates[language] || templates.ES;
}

function getPresupuestoPrimerPaso(language, caminoId) {
  if (isRutaSenderismo(caminoId)) {
    return '';
  }

  const textos = {
    ES: 'Acabas de dar tu primer paso en el Camino de Santiago. Gracias por haber pensado en Rutas Meigas para hacerlo.\n\n',
    EN: "You've just taken your first step on the Camino de Santiago. Thank you for choosing Rutas Meigas to make it happen.\n\n",
    DE: 'Jede Pilgerreise beginnt mit einem ersten Schritt - und oft wird daraus eine Erfahrung, die weit über die Strecke hinausgeht.\n\n'
  };

  return textos[language] || '';
}

function isRutaSenderismo(caminoId) {
  return caminoId == 37 || caminoId == 38 || caminoId == 164 || caminoId == 165 || caminoId == 166 || caminoId == 167;
}

function getPresupuestoDespedida(language, caminoId) {
  if (isRutaSenderismo(caminoId)) {
    return '';
  }

  const textos = {
    ES: '¡Buen Camino!\n',
    EN: 'Buen Camino!\n',
    DE: 'Gruss und Buen Camino\n'
  };

  return textos[language] || '';
}
